import PropTypes from 'prop-types';
import React, { Component } from 'react';

// TODO Review use of this class by reading https://lets-do-this.atlassian.net/browse/LDS-42
import { GLOBAL_FORM_STYLES_CLASS } from '@/globalClasses';

import Tooltip from '../../../Tooltip';
import { isMobileOrTablet } from '../../../../utils/browserDetection';

import {
  label as labelStyle,
  small as smallStyle,
  stars,
  large as largeStyle,
  starsWrapper,
  tooltipSmall,
  tooltipMedium,
  tooltipLarge,
} from './styles.module.css';

/*
 * Star Rating Component.
 * Original npm package does not feature hover states, but this fork does.
 * See https://github.com/ronihcohen/react-star-rating-component/tree/mouse-hover-effect.
 * PR here: https://github.com/voronianski/react-star-rating-component/pull/23
 */

class StarRatingComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };
  }

  // eslint-disable-next-line camelcase, react/sort-comp
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { value } = nextProps;

    if (value != null && value !== this.state.value) {
      this.setState({ value });
    }
  }

  onChange(value) {
    const { editing } = this.props;

    if (!editing) {
      return;
    }

    this.setState({ value });
  }

  onStarClick(index, value, name) {
    const { onStarClick, editing } = this.props;

    if (!editing) {
      return;
    }

    onStarClick(index, value, name);
  }

  onStarOverOrLeave(index) {
    this.setState({ hover: index });
  }

  renderStars() {
    const { name, starCount, editing, showTooltip, tooltipLabels } = this.props;

    const { hover } = this.state;
    let { value } = this.state;

    if (hover && editing) {
      value = hover;
    }

    const starStyles = () => ({
      float: 'right',
      cursor: editing ? 'pointer' : 'default',
      position: 'relative',
    });

    const radioStyles = {
      display: 'none',
      position: 'absolute',
      marginLeft: -9999,
    };

    // populate stars
    const starNodes = [];

    for (let i = starCount; i > 0; i--) {
      const index = i - 1;
      const id = `${name}_${i}`;
      const starNodeInput = (
        <input
          key={`input_${id}`}
          style={radioStyles}
          className="dv-star-rating-input"
          type="radio"
          name={name}
          id={id}
          value={i}
          checked={value === i}
          /*
           * Needed to change the onChange prop here to this.props.onChange
           * to use higher order component's onChange function instead.
           */
          onChange={() => this.props.onChange}
          onClick={() => this.onChange(i, name)}
        />
      );

      let starClassName;

      if (this.props.small) {
        starClassName = smallStyle;
      } else if (this.props.large) {
        starClassName = largeStyle;
      } else {
        starClassName = labelStyle;
      }

      // eslint-disable-next-line no-unused-vars
      let tooltipClassName;

      if (this.props.small) {
        tooltipClassName = tooltipSmall;
      } else if (this.props.large) {
        tooltipClassName = tooltipLarge;
      } else {
        tooltipClassName = tooltipMedium;
      }

      const starNodeLabel = (
        <label
          key={`label_${id}`}
          style={starStyles(i, value)}
          className={starClassName}
          htmlFor={id}
          onClick={() => this.onStarClick(i, value, name)}
          onMouseOver={() => this.onStarOverOrLeave(i)}
          onMouseLeave={() => this.onStarOverOrLeave(null)}
        >
          {this.renderIcon(i, value, name)}

          {// Do not show tooltip on mobile or tablet.
          // Note: This is due to a touchscreen subtlety in which when a user taps a clickable
          //       event it first checks if a hover event causes a state change. If so, it mimics
          //       a hover event, and does not propegate the click.
          !isMobileOrTablet &&
            showTooltip &&
            tooltipLabels[index] &&
            hover &&
            hover === i && <Tooltip text={tooltipLabels[index]} />}
        </label>
      );

      starNodes.push(starNodeInput);
      starNodes.push(starNodeLabel);
    }

    return starNodes;
  }

  renderIcon(index, value, name) {
    const { renderStarIcon, renderStarIconHalf } = this.props;

    if (
      typeof renderStarIconHalf === 'function' &&
      Math.ceil(value) === index &&
      value % 1 !== 0
    ) {
      return renderStarIconHalf(index, value, name);
    }

    if (typeof renderStarIcon === 'function') {
      return renderStarIcon(index, value, name);
    }

    return <i style={{ fontStyle: 'normal' }}>&#9733;</i>;
  }

  render() {
    const { editing, className } = this.props;
    const classes = [
      GLOBAL_FORM_STYLES_CLASS,
      'dv-star-rating',
      !editing ? 'dv-star-rating-non-editable' : '',
      starsWrapper,
      className,
      this.props.small ? '' : stars,
    ];

    return (
      <div style={{ position: 'relative' }} className={classes.join(' ')}>
        {this.renderStars()}
      </div>
    );
  }
}

StarRatingComponent.propTypes = {
  name: PropTypes.string.isRequired,
  small: PropTypes.bool,
  large: PropTypes.bool,
  value: PropTypes.number,
  editing: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  starCount: PropTypes.number,
  // eslint-disable-next-line react/no-unused-prop-types
  starColor: PropTypes.string,
  onStarClick: PropTypes.func,
  renderStarIcon: PropTypes.func,
  renderStarIconHalf: PropTypes.func,
  showTooltip: PropTypes.bool,
  tooltipLabels: PropTypes.arrayOf(PropTypes.string),
};

StarRatingComponent.defaultProps = {
  onChange: () => {},
  onStarClick: () => {},
  renderStarIcon: undefined,
  renderStarIconHalf: undefined,
  small: false,
  large: false,
  className: '',
  starCount: 5,
  value: null,
  editing: true,
  starColor: '#ffb400',
  emptyStarColor: '#333',
  showTooltip: false,
  tooltipLabels: [
    'Total shocker',
    'Not great',
    'A-OK',
    'Awesome',
    'As good as it gets!',
  ],
};

export default StarRatingComponent;
